import { useQuery } from "@tanstack/react-query";
import { jeopardyApi } from "../api/jeopardy";

export const useFetchJeopardySeverity = () => {

    const { data, isLoading, isError, isSuccess, error } = useQuery({
        queryKey: ["jeopardy-severity"],
        queryFn: () => jeopardyApi.fetchJeopardyCount(),
    });

    return { data: isSuccess ? data.data.items : [], isLoading, isError, error };

};